import React from "react";
import statsBg from "../assets/image/state-bg.png";

const stats = [
  {
    number: "700M+",
    label: "Ayushman Bharat Health Accounts (ABHA)",
  },
  {
    number: "600M+",
    label: "Health Records Linked",
  },
  {
    number: "400K+",
    label: "Verified Facilities on HFR",
  },
  {
    number: "600K+",
    label: "Verified Healthcare Professionals",
  },
];

const StatsSection = () => {
  return (
    <section className="stats-section">
      {/* Background image */}
      <div
        className="stats-bg"
        style={{ backgroundImage: `url(${statsBg})` }}
      />

      <div className="container stats-container">
        <div className="row align-items-center stats-row">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="col-6 col-md-3 stats-col"
            >
              {/* Divider line — show before every col except first */}
              {index !== 0 && <div className="stats-divider" />}

              <div className="stats-item">
                <h2 className="stats-number">{stat.number}</h2>
                <p className="stats-label">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
